import React from 'react';

function OrderTaxExemptTemplate ({ modelAttributes }) {

	const { OverrideTax, ShowTaxOverride } = modelAttributes;
	return (
		<>
			{ShowTaxOverride && (
				<div className="lpForm">
					<div className="taxExemptCheckbox field fieldCheckbox">
						<input type="checkbox" id="taxExemptCheckbox" defaultChecked={OverrideTax} />
						<label htmlFor="taxExemptCheckbox">Order is tax exempt</label>
					</div>
				</div>
			)}
		</>
	);

}

export default OrderTaxExemptTemplate;
